import React from 'react';
import IdIntro from 'ui/sections/notarize/pages/IdIntro';
import { NotarizationStatus } from 'utils/enums';

export default class SpouseIdIntro extends IdIntro {
  static forSpouse = true;
  static notarizationSection = NotarizationStatus.ID_VERIFICATION_SPOUSE;
}
